import {Controller} from "stimulus"

export default class extends Controller {

    connect() {
        console.log("hello from business-index");
    }

    updateReport(e) {
        console.log("report changed")
        window.location.href = this.reportUrl();
    }

    // The index's filter bar as a query string. Split out of updateReport so the
    // assembly can be asserted on -- navigation is the only other effect it has,
    // and jsdom cannot follow it.
    reportUrl() {
        const contractor = document.getElementById('is_contractor').checked;
        const isActive = document.getElementById('is_active').checked;
        const isLicensed = document.getElementById('is_licensed').checked;
        // Only rendered under the Finance hat, so this is null on every other deployment.
        const vendorEl = document.getElementById('is_vendor')
        const jurisdiction = document.getElementById("jurisdiction_id")
        const residency = document.getElementById("residency")
        const homeBased = document.getElementById("home_based")
        const classificationsEl = document.getElementById("classifications")
        const excludeClassificationsEl = document.getElementById("exclude_classifications")
        const statusFlags = document.getElementById("status_flags")
        const name = document.getElementById("name").value
        let reportUrl = 'businesses?'
        let params = []
        if (classificationsEl) {
            const selectedCodes = Array.from(classificationsEl.selectedOptions).map(option => encodeURIComponent(option.value));
            if (selectedCodes.length > 0) {
                params.push('classifications=' + selectedCodes.join(','));
            }
        }
        if (excludeClassificationsEl) {
            const selectedExcludes = Array.from(excludeClassificationsEl.selectedOptions).map(option => encodeURIComponent(option.value));
            if (selectedExcludes.length > 0) {
                params.push('exclude_classifications=' + selectedExcludes.join(','));
            }
        }
        if (statusFlags) {
            const selectedFlags = Array.from(statusFlags.selectedOptions).map(option => encodeURIComponent(option.value));
            if (selectedFlags.length > 0) {
                params.push('status_flags=' + selectedFlags.join(','));
            }
        }
        if (contractor) {
            params.push('is_contractor=true')
        }
        if (isActive) {
            params.push('is_active=true')
        }
        if (isLicensed) {
            params.push('is_licensed=true')
        }
        if (vendorEl && vendorEl.checked) {
            params.push('is_vendor=true')
        }
        if (jurisdiction) {
            params.push('jurisdiction_id=' + encodeURIComponent(jurisdiction.value))
        }
        if (residency) {
            params.push('residency=' + encodeURIComponent(residency.value))
        }
        if (homeBased) {
            params.push('home_based=' + encodeURIComponent(homeBased.value))
        }
        if (name) {
            params.push('name=' + encodeURIComponent(name))
        }
        return reportUrl + params.join('&');
    }
}
